import { render, staticRenderFns } from "./Balance.vue?vue&type=template&id=ef623432"
import script from "./Balance.vue?vue&type=script&lang=js"
export * from "./Balance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports